import React from 'react';
import {PLAY_BY_PLAY} from "../../../../play-by-play-widget/play-by-play-widget.consts";
import {MatchEventsModuleStages} from "./match-events-module.stages";
import {PlayByPlayWidgetAsync} from "../../../../play-by-play-widget/components/play-by-play-widget.async";
import {observer} from "mobx-react";

export const MatchEventModuleTabContent = observer(({controller, gameId, location}) => {
  const {state: {isCommentaryTab}} = controller;

  const playByPlayProps = {
    gameId,
    location,
    source: PLAY_BY_PLAY.ANALYTICS.SOURCE.tab,
  }

  return isCommentaryTab ? <PlayByPlayWidgetAsync {...playByPlayProps}/> : <MatchEventsModuleStages controller={controller}/>
})
